import "./FeaturesTech.css";
import "./FeaturesTechResponsive.css";

export function FeaturesTech() {
	return `
    <section class="features_tech">
      <div class="tech_specs_content">
					<div class="tech_specs_block">
						<p class="tech_title">Audio Technology</p>
						<p class="tech_text">
							Custom-tuned 40mm Resonance™ drivers for deep bass.<br />
							Ultra-low distortion signal processing.<br />
							Adaptive Sound Sculpting™ — real-time EQ.<br />
							Spatial Audio Calibration with dynamic head tracking.<br />
							Natural Voice Isolation for calls, focus, and immersive listening.<br />
							Pressure-balancing acoustic vents for long-wear comfort.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Intelligence</p>
						<p class="tech_text">
							Dual noise-targeting microphones.<br />
							Internal ear-position mic for personalized audio tuning.<br />
							Proximity & motion sensors to detect wear and usage.<br />
							Gesture-aware force sensor for effortless control.<br />
							Accelerometer-assisted voice capture for clarity on the move.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Power</p>
						<p class="tech_text">
							Custom-designed <span>R2 Sound Core</span> chip.<br />
							Advanced audio algorithms tuned for emotional clarity.<br />
							Onboard neural audio engine for Spatial Audio and Adaptive EQ.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Controls</p>
						<p class="tech_text">
							Tap once to play/pause or answer a call.<br />
							Tap twice to skip forward or end a call.<br />
							Tap three times to rewind.<br />
							Press and hold to access voice assistant.<br />
							Automatic mute when removed, smart resume when worn.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Built for the Elements</p>
						<p class="tech_text">
							Rated <span>IPX4</span> for sweat and weather resistance.<br />
							Designed for long sessions, light activity, or relaxed stillness.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Battery</p>
						<p class="tech_text">
							Up to <span>36 hours</span> total listening time with case.<br />
							Up to <span>6.5 hours</span> on a single charge.<br />
							Fast charge: <span>10 minutes = 2 hours of play.</span><br />
							USB-C charging + Qi-compatible wireless charging.<br />
							LED status light + Find My compatible tone alert.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Connectivity</p>
						<p class="tech_text">
							Bluetooth® 5.3 low-latency audio.<br />
							Multipoint connection with auto handoff.<br />
							Seamless pairing across all your devices.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Materials</p>
						<p class="tech_text">
							100% recycled aluminum in internal frames.<br />
							Bio-based mesh ear padding.<br />
							Rare earth magnets sourced from reclaimed materials.<br />
							Plastic-free, fiber-based packaging.<br />
							Assembled in Zero Waste-certified facilities.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Sustainability & Materials</p>
						<p class="tech_text">
							100% recycled aluminum in internal frames.<br />
							Bio-based mesh ear padding.<br />
							Rare earth magnets sourced from reclaimed materials.<br />
							Plastic-free, fiber-based packaging.<br />
							Assembled in Zero Waste-certified facilities.<br />
						</p>
					</div>
				</div>
    </section>
  `;
}